import { useInvoiceCurrencies } from "../useInvoiceCurrencies";
import { Invoice } from "../../types/InvoiceTypes";
import { formatAmount } from "../../utils/numbers/money";
import { Message } from "../../components/common";
import { UIStatus } from "../../types/GlobalTypes";

export const useValidateInvoiceAmountThreshold = (
  invoice?: Invoice,
  context: "form" | "sidebar" = "form"
) => {
  const invoiceCurrencies = useInvoiceCurrencies(invoice);

  if (!invoice) {
    return {
      isValid: false,
      msg: "",
    };
  }

  const { amount, max_amount_threshold, min_amount_threshold } = invoice;
  const outgoingCurrency = invoiceCurrencies!.outgoing;
  const incomingCurrency = invoiceCurrencies!.incoming;

  if (min_amount_threshold && amount > 0 && amount < min_amount_threshold) {
    const minFormattedAmount = formatAmount(
      min_amount_threshold || 0,
      outgoingCurrency.decimals
    );

    return {
      isValid: false,
      msg:
        context === "form" ? (
          <div className="font-semibold text-orange-500 text-right mt-4">
            Sum of invoice has to be at least {minFormattedAmount}{" "}
            {incomingCurrency!.code} when payout in {outgoingCurrency.code}.
          </div>
        ) : (
          <Message
            heading="Invoice amount too low"
            text={`For payouts in ${outgoingCurrency.code}, the invoice amount has to be at least ${minFormattedAmount} ${incomingCurrency!.code}.`}
            type={UIStatus.ERROR}
          />
        ),
    };
  }

  if (max_amount_threshold && amount > max_amount_threshold) {
    const maxFormattedAmount = formatAmount(
      max_amount_threshold || 0,
      outgoingCurrency.decimals
    );

    return {
      isValid: false,
      msg:
        context === "form" ? (
          <div className="font-semibold text-orange-500 text-right mt-4">
            Sum of invoice has to be at most {maxFormattedAmount}{" "}
            {incomingCurrency!.code} when payout in {outgoingCurrency.code}.
          </div>
        ) : (
          <Message
            heading="Split invoice"
            text={`For payouts in ${outgoingCurrency.code}, the invoice amount has to be at most ${maxFormattedAmount} ${incomingCurrency!.code}. Please split the job across several invoices.`}
            type={UIStatus.ERROR}
          />
        ),
    };
  }

  return { isValid: true };
};
